import { render } from "./EmailConfirmation.vue?vue&type=template&id=135413ae&scoped=true"
import script from "./EmailConfirmation.vue?vue&type=script&lang=js"
export * from "./EmailConfirmation.vue?vue&type=script&lang=js"

import "./EmailConfirmation.vue?vue&type=style&index=0&id=135413ae&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135413ae"]])

export default __exports__